import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import { useLocation } from 'react-router-dom';

import ga from 'react-ga';

const f = title => (...args) => console.log(title, ...args);
const mockGa = {
  set: () => {},
  pageview: f('tracker.pageview'),
};

const isDev = process.env.NODE_ENV !== 'production';
const tracker = isDev ? mockGa : ga;

if (!isDev) ga.initialize('UA-153111142-1', { siteSpeedSampleRate: 100 });

function AnalyticsComponent({ children }) {
  const location = useLocation();
  const locationString = `${location.pathname}${location.search}`;

  useEffect(() => {
    tracker.set({ location: locationString });
    tracker.pageview(locationString);
  }, [locationString]);

  return <div>{children}</div>;
}

AnalyticsComponent.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  children: PropTypes.any.isRequired,
};

export default AnalyticsComponent;
